import axios from 'axios';
import { triggerCustomEvent } from '../utils/events';

let cancel;
const CancelToken = axios.CancelToken;

class HeaderSearch {
  constructor(el, $inputMobile, $inputDesktop) {
    this.dom = {
      $inputMobile,
      $inputDesktop,
      $formMobile: el._$('.header__search-form--mobile'),
      $formDesktop: el._$('.header__search-form--desktop'),
      $commonTermsDefault: el._$$('.header__search-common-terms--default'),
      $commonTermsResults: el._$$('.header__search-common-terms--results'),
      $commonTermsLoading: el._$$('.header__search-common-terms--loading'),
      $commonTermsNoResults: el._$$('.header__search-common-terms--no-results'),
      $buttonClearMobile: el._$('.header__search-mobile-button--clear'),
      $buttonClearDesktop: el._$('.header__search-input-desktop-button--clear')
    };
    this.$inputDesktop = $inputDesktop;

    this.inputValue = '';
    this.searchFetchUrl = el.dataset.searchFetchUrl;
    this.searchKeyword = el.dataset.searchKeyword;
    this.searchPageLink = el.dataset.searchPageLink;
    this.addListeners();
  }

  addListeners() {
    const {
      $formMobile,
      $formDesktop,
      $inputMobile,
      $inputDesktop,
      $buttonClearMobile,
      $buttonClearDesktop
    } = this.dom;

    [$formMobile, $formDesktop].forEach((form) =>
      form._on('submit', ::this.handleSubmit)
    );
    [$inputMobile, $inputDesktop].forEach((input) => {
      input._on('input', ::this.handleInputChange);
    });
    $buttonClearMobile._on('click', ::this.handleClearClick);
    $buttonClearDesktop._on('click', ::this.handleClearClick);
  }

  handleClearClick() {
    const {
      $inputMobile,
      $inputDesktop,
      $commonTermsLoading,
      $commonTermsDefault,
      $commonTermsResults,
      $commonTermsNoResults
    } = this.dom;

    $commonTermsLoading.forEach((version) => (version.hidden = true));
    $commonTermsDefault.forEach((version) => (version.hidden = false));
    $commonTermsResults.forEach((version) => (version.hidden = true));
    $commonTermsNoResults.forEach((version) => (version.hidden = true));

    [$inputMobile, $inputDesktop].forEach((input) => (input.value = ''));
    triggerCustomEvent($inputMobile, 'change');
    $inputMobile.focus();
  }

  handleInputChange(e) {
    const { $inputMobile, $inputDesktop, $formMobile, $formDesktop } = this.dom;

    [$inputMobile, $inputDesktop]
      .filter((input) => input !== e.target)
      .forEach((input) => (input.value = e.target.value));

    if ($inputMobile.value) {
      $formMobile.classList.add('header__search-form--show-clear');
      $formDesktop.classList.add('header__search-form--show-clear');
    } else {
      $formMobile.classList.remove('header__search-form--show-clear');
      $formDesktop.classList.remove('header__search-form--show-clear');
    }

    if ($inputMobile.value.trim().length >= 2) {
      if (cancel) {
        cancel('Operation canceled by the user.');
      }
      triggerCustomEvent($formMobile, 'submit', {
        bubbles: true,
        cancelable: true
      });
    }
  }

  async handleSubmit(e) {
    e.preventDefault();
    const {
      $inputMobile,
      $commonTermsLoading,
      $commonTermsDefault,
      $commonTermsResults,
      $commonTermsNoResults
    } = this.dom;
    const { value } = $inputMobile;
    const length = value.trim().length;

    $commonTermsLoading.forEach((version) => (version.hidden = false));
    $commonTermsDefault.forEach((version) => (version.hidden = true));
    $commonTermsResults.forEach((version) => (version.hidden = true));
    $commonTermsNoResults.forEach((version) => (version.hidden = true));

    if (length >= 2) {
      try {
        this.inputValue = value;
        const response = await axios({
          method: 'get',
          url: this.searchFetchUrl,
          cancelToken: new CancelToken((c) => {
            cancel = c;
          }),
          params: {
            [this.searchKeyword]: value
          }
        });

        this.fillSuggestedResults(response);
      } catch (error) {
        console.error(error);
      }
    }
  }

  fillSuggestedResults(response) {
    const {
      $commonTermsDefault,
      $commonTermsResults,
      $commonTermsNoResults,
      $commonTermsLoading
    } = this.dom;

    if (response?.data?.SuggestedResults?.length) {
      $commonTermsLoading.forEach((version) => (version.hidden = true));
      $commonTermsDefault.forEach((version) => (version.hidden = true));
      $commonTermsNoResults.forEach((version) => (version.hidden = true));
      $commonTermsResults.forEach((version) => (version.hidden = false));
      /* eslint-disable indent */
      $commonTermsResults.forEach((version) => {
        version._$('.header__search-common-terms-list').innerHTML =
          response.data.SuggestedResults.map(
            ({ Category, Result, Link }) =>
              `<li class="header__search-common-terms-item">
            <a href="${Link}">${Result}</a>
            <span>${Category}</span>
          </li>`
          ).join('');
      });
      /* eslint-enable indent */
      $commonTermsResults.forEach((version) => {
        version
          ._$('.btn')
          .setAttribute(
            'href',
            `${this.searchPageLink}?${this.searchKeyword}=${this.inputValue}`
          );
      });
    } else {
      $commonTermsDefault.forEach((version) => (version.hidden = true));
      $commonTermsResults.forEach((version) => (version.hidden = true));
      $commonTermsNoResults.forEach((version) => (version.hidden = false));

      $commonTermsNoResults.forEach((version) => {
        version
          ._$('.btn')
          .setAttribute(
            'href',
            `${this.searchPageLink}?${this.searchKeyword}=${this.inputValue}`
          );
      });
    }
  }
}

export default HeaderSearch;
